import { LitElement, html } from './-global.min.js'

class HHLoadMore extends LitElement {
  static properties = {
    url: {
      type: String,
    },
    position: {
      type: String,
    },
    'target-selector': {
      type: String,
    },
  }

  constructor() {
    super()
    this.position = 'next'
  }

  connectedCallback() {
    super.connectedCallback()
    this.addEventListener('submit', this.handleLoadMore.bind(this))
    this.originalLastItem = document.querySelector('.js-product-grid-list li:last-child .js-product-card-title')

  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  async handleLoadMore(e) {
    e.preventDefault()
    try {
      const url = this['url']
      const targetSelector = this['target-selector']

      this.setButtonLoading()
      this.setPageUrl(url)

      const res = await fetch(url)
      const data = await res.text()
      const dataDom = new DOMParser().parseFromString(data, 'text/html')
      const newData = dataDom.querySelector(targetSelector)

      document
        .querySelector(targetSelector)
        .insertAdjacentHTML(
          this.position === 'previous' ? 'afterbegin' : 'beforeend',
          newData.innerHTML
        )

      this.rerenderComponent(dataDom)

      if (this.position === 'next') {
        setTimeout(() => {
          this.originalLastItem?.focus()
        }, 0)
      }
    } catch (error) {
      console.error(error)
    }
  }

  setButtonLoading() {
    const buttonEl = this.querySelector('.js-load-more, button[type="submit]')

    buttonEl.classList.add('is-loading')
    buttonEl.setAttribute('disabled', true)
  }

  rerenderComponent(data) {
    if (!data) return
    const elId = `#${this.getAttribute('id')}`

    const newLoadMore = data.querySelector(elId)?.outerHTML || ''
    this.outerHTML = newLoadMore
  }

  setPageUrl(url) {
    window.history.replaceState({}, '', url)
  }

  render() {
    return html` <slot></slot> `
  }
}

customElements.define('hh-load-more', HHLoadMore)
